/** DOC Great Walk `place_id` values (track-level, not individual huts). */
export const DOC_GREAT_WALK_PLACE_IDS = {
  'Abel Tasman Coast Track': 875,
  'Heaphy Track': 876,
  'Kepler Track': 872,
  'Lake Waikaremoana': 878,
  'Milford Track': 873,
  'Paparoa Track': 880,
  'Rakiura Track': 877,
  'Routeburn Track': 874,
  'Tongariro Northern Circuit': 879,
  'Whanganui Journey': 881,
};

export const DOC_GREAT_WALK_DEFAULT_NIGHTS = {
  'Abel Tasman Coast Track': 3,
  'Heaphy Track': 4,
  'Kepler Track': 4,
  'Lake Waikaremoana': 4,
  'Milford Track': 3,
  'Paparoa Track': 2,
  'Rakiura Track': 3,
  'Routeburn Track': 3,
  'Tongariro Northern Circuit': 4,
  'Whanganui Journey': 3,
};

const DOC_BOOKING_BASE =
  'https://bookings.doc.govt.nz/Web/Default.aspx#!greatwalk-result';

export function resolveDocGreatWalkPlaceId(trackName) {
  if (!trackName) return null;
  return DOC_GREAT_WALK_PLACE_IDS[trackName] ?? null;
}

export function buildDocGreatWalkBookingUrl({
  placeId,
  arrivalDate,
  nights,
  totalParty,
}) {
  const params = new URLSearchParams();
  params.set('place_id', String(placeId));
  if (arrivalDate) params.set('arrival_date', arrivalDate);
  if (nights != null && nights > 0) params.set('nights', String(nights));
  if (totalParty != null && totalParty > 0) {
    params.set('total_party', String(totalParty));
  }
  return `${DOC_BOOKING_BASE}?${params.toString()}`;
}

export function buildDocGreatWalkBookingUrlForTrack({
  trackName,
  arrivalDate,
  nights,
  totalParty,
}) {
  const placeId = resolveDocGreatWalkPlaceId(trackName);
  if (!placeId) return 'https://bookings.doc.govt.nz';
  const resolvedNights =
    nights ??
    (trackName ? DOC_GREAT_WALK_DEFAULT_NIGHTS[trackName] : null) ??
    1;
  return buildDocGreatWalkBookingUrl({
    placeId,
    arrivalDate,
    nights: resolvedNights,
    totalParty,
  });
}
